import type { CSSProperties } from "react";
import { C, mono, type } from "../theme.ts";

const TONE = { faint: C.inkFaint, ghost: C.inkGhost, soft: C.inkSoft, flag: C.flagInk, alert: C.alert } as const;

/**
 * The mono line for ids, durations, counts and dates — a row's
 * `id · value · due · mode`, the sheet's `due · mode · mins`, a chase or
 * wait line. Never a value's name on its own — that is `ValueLabel`.
 */
export function MetaLine({
  children, size = "small", tone = "faint", as: Tag = "p", style,
}: {
  children: React.ReactNode;
  size?: keyof typeof type;
  tone?: keyof typeof TONE;
  as?: "p" | "span" | "div";
  style?: CSSProperties;
}) {
  return (
    <Tag style={{ margin: 0, fontFamily: mono, fontSize: type[size], color: TONE[tone], ...style }}>
      {children}
    </Tag>
  );
}
